<template>
  <div>
    <!-- SLIDER COMPONENT -->
    <app-slider></app-slider>
    <!-- CONTENT -->
    <div v-if="Array.isArray(homepage) && homepage.length" class="home-content">
      <div class="box responsive-box" v-for="home in homepage" :key="home.Position">
        <div class="box__image">
          <!-- İmage -->
          <progressive-img :src="file(home.ImageLink)" :alt="home.TitleLink">
            <div
              slot-scope="{visible}"
              v-if="visible"
              class="loading-spinner-flex"
              style="width:100%;height:100%"
            >
              <i class="diginity dg-loading diginity-is-spinning"></i>
            </div>
          </progressive-img>
        </div>
        <div class="box__content">
          <div class="title">
            <!-- titleLink -->
            <router-link :to="home.TitleLink">{{ home.Key }}</router-link>
          </div>
          <div class="text">
            <!-- contentLink -->
            <router-link :to="home.ContentLink">
              <span class="head">{{ home.Title }}</span>
              <span class="content">{{ home.Content }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Yükleme ve Hata component'leri -->
    <template>
      <div v-if="Array.isArray(homepage)&&!homepage.length" class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <!-- error -->
      <p v-if="homepage==undefined" class="response-error">
        <span>{{ lng == 'tr' ? 'Kayıt Bulunamadı' : 'No Records Found' }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Slider from "./shared/Slider.vue";
export default {
  computed: {
    ...mapGetters(["homepage", "t", "file", "lng"])
  },
  watch: {
    // Dil değiştiğinde HOME page listelerini yeniden getirecek
    lng(newValue, oldValue) {
      this.$store.dispatch("homepage_list", this.lng);
    }
  },
  created() {
    // 'store_modules/Actions.js' {homepage_list}
    this.$store.dispatch("homepage_list", this.lng);
    this.$scrollTo("body", this.$store.state.scrollSpeed);
  },
  components: {
    appSlider: Slider
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/colors"; // color mixins
.box__content {
  padding: 20px 0;
  margin-top: 5px;
  text-align: center;
  .title {
    text-align: center;
    margin-bottom: 3px;
    a {
      display: inline-block;
      padding: 5px 10px;
      border: 2px solid #949195;
      border-left-color: transparent;
      border-right-color: transparent;
      color: $main;
      &:hover {
        color: $mainLight;
      }
    }
  }
  .text {
    a {
      display: flex;
      flex-direction: column;
      color: #555;
      font-size: 14px;
      &:hover {
        color: $mainLight;
      }
      span {
        display: inline-block;
        padding: 3px 5px;
      }
    }
  }
}
.home-content {
  display: flex;
  flex-wrap: wrap;
  .box {
    padding: 40px 0 10px;
    background: #e7e7e7;

    .box__image {
      width: 150px;
      height: 150px;
      overflow: hidden;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      margin: 0 auto;
      background: #fff;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
      img {
        width: 100%;
      }
    }
    &:nth-child(odd) {
      background: #dedede;
    }
  }
}

.responsive-box {
  width: 33.33333%;
  @media screen and (max-width: 768px) {
    width: 50%;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }
}
</style>